import { createSlice } from "@reduxjs/toolkit";


const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    userName: '',
    paymentIntentId:null
  },
  reducers: {
    authenticated: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated
      state.userName = action.payload.userName;
    },
  
    resetAuth: (state) => {
      state.isAuthenticated = false
      state.userName = ''
    }
    
},
});

export const { authenticated, resetAuth } = authSlice.actions;
export default authSlice.reducer;